module.exports = __webpack_public_path__ + "static/media/EXC_DP_RGB_PS.e7157350.svg";